// English for the AI costs + profit calculator screens (2026-10-22). French string = key.
const m: Record<string, string> = {
  // Profit calculator
  'Calculateur de profit': 'Profit calculator',
  'Allumez ou éteignez chaque coût': 'Switch each cost on or off',
  'Impression (fabrication)': 'Printing (production)',
  'Commissions': 'Commissions',
  'Charges': 'Expenses',
  'Coût IA': 'AI cost',
  'Coûts à déduire': 'Costs to deduct',
  'Du encaissé au résultat': 'From collected to result',
  'Résultat': 'Result',
  'Marge {n} %': 'Margin {n} %',
  'Marge —': 'Margin —',
  '{x} DH par commande': '{x} DH per order',
  '— par commande': '— per order',
  '= le Profit net officiel': '= the official net profit',
  'Tout allumer': 'All on',
  'Tout éteindre': 'All off',
  'incomplet': 'incomplete',
  'Ouvrir le calculateur de profit': 'Open the profit calculator',
  // Home
  '{x} DH avant coût IA': '{x} DH before AI cost',
  '{x} DH / commande': '{x} DH / order',
  'aucune commande': 'no order',
  'partiel': 'partial',
  "Coût IA : {x} DH aujourd'hui": 'AI cost: {x} DH today',
  '×{r} la moyenne sur 7 jours ({a} DH/jour)': '×{r} the 7-day average ({a} DH/day)',
  'Coût IA : écart {x} % avec OpenRouter': 'AI cost: {x} % gap with OpenRouter',
  'des appels ne sont pas comptés': 'some calls are not counted',
  'nous comptons plus qu’OpenRouter': 'we count more than OpenRouter',
  'après pub, IA, fabrication et livraison': 'after ads, AI, production and delivery',
  // Rapports › Coûts IA
  'Coûts IA': 'AI costs',
  'Sur la période': 'Over the period',
  'Par commande livrée': 'Per delivered order',
  'Par fonction': 'By feature',
  'Par modèle': 'By model',
  'Commandes les plus coûteuses': 'Most expensive orders',
  'Aucun appel sur la période.': 'No call over the period.',
  'Aucune commande sur la période.': 'No order over the period.',
  'Conforme à OpenRouter': 'Matches OpenRouter',
  'écart {x} %': 'gap {x} %',
  'clé': 'key',
  'Vérification OpenRouter : pas encore de journée complète à comparer.': 'OpenRouter check: no full day to compare yet.',
  'Suivi depuis le {d}': 'Tracked since {d}',
  'Suivi pas encore démarré': 'Tracking not started yet',
  'toutes les fonctions depuis le {d}': 'every feature since {d}',
  '{n} appels': '{n} calls',
  '{n} appels en attente de leur prix': '{n} calls waiting for their price',
  '{n} jours : {x} DH de coût IA': '{n} days: {x} DH of AI cost',
  // Réel / Payé + the Claude check (« Fournisseurs IA », 2026-10-23)
  'Réel': 'Actual',
  'Payé': 'Paid',
  'réel': 'actual',
  'Coût IA réel ou payé': 'AI cost: actual or paid',
  'Coût IA réel : la valeur de tous les appels, même ceux couverts par le crédit Claude': 'Actual AI cost: the value of every call, even those covered by the Claude credit',
  'Coût IA payé : ce qui est vraiment dépensé (OpenRouter + Claude hors crédit)': 'Paid AI cost: what is really spent (OpenRouter + Claude outside the credit)',
  'Payé = réel : aucun appel couvert par le crédit Claude sur la période': 'Paid = actual: no call covered by the Claude credit over the period',
  'avec coût IA payé': 'with paid AI cost',
  'avec coût IA réel': 'with actual AI cost',
  'Profit net avec coût IA payé (OpenRouter + Claude hors crédit)': 'Net profit with the paid AI cost (OpenRouter + Claude outside the credit)',
  'avec IA payé : {x} DH': 'with paid AI: {x} DH',
  'Réel = valeur de tous les appels · Payé = OpenRouter + Claude hors crédit': 'Actual = value of every call · Paid = OpenRouter + Claude outside the credit',
  'Payé = OpenRouter + Claude hors crédit': 'Paid = OpenRouter + Claude outside the credit',
  'payé {x} DH': 'paid {x} DH',
  'réel {x} DH': 'actual {x} DH',
  'Par fournisseur': 'By provider',
  'Crédit Claude : {a} DH utilisés · {b} DH payés': 'Claude credit: {a} DH used · {b} DH paid',
  'Coût IA : écart {x} % avec Claude': 'AI cost: {x} % gap with Claude',
  'nous comptons plus que Claude': 'we count more than Claude',
  'Conforme à Claude': 'Matches Claude',
  'Vérification Claude : pas encore de comparaison.': 'Claude check: no comparison yet.',
  'montant console': 'console amount',
  'API Anthropic': 'Anthropic API',
  // Feature names (lib/aiFeatures.ts)
  'Réponses WhatsApp': 'WhatsApp replies',
  'Lecture des demandes': 'Reading requests',
  'Mémoire client': 'Client memory',
  'Infos de commande': 'Order details',
  'Promesses à tenir': 'Open promises',
  'Analyse des photos': 'Photo analysis',
  'Recherche de visages': 'Face finder',
  'Contrôle des pages': 'Page check',
  'Légendes': 'Captions',
  'Lecture des reçus': 'Receipt reading',
  'Satisfaction': 'Satisfaction',
  'Annulations': 'Cancellations',
  'Photos de travers': 'Sideways photos',
  'Retouches d’album': 'Album edits',
  'Outils admin': 'Admin tools',
  'Type d’image reçue': 'Incoming image type',
  'Messages vocaux': 'Voice notes',
  'Modèles de pages': 'Page templates',
  'Mots-clés couvertures': 'Cover keywords',
  'Suggestion de couverture': 'Cover suggestion',
  'Mise en page': 'Layout',
  'Captures de l’aperçu': 'Preview screenshots',
  'Questions au manager': 'Questions to the manager',
  'Réponses enregistrées': 'Saved replies',
  'Brain : affiner': 'Brain: refine',
  'Brain : généraliser': 'Brain: generalise',
  'Opérateur (patron)': 'Operator (owner)',
  'Relais manager': 'Manager relay',
  'Notes d’aperçu': 'Preview notes',
  'Notes d’aperçu (modèle fort)': 'Preview notes (strong model)',
  'Notes d’aperçu (image)': 'Preview notes (image)',
  'Notes à clarifier': 'Notes to clarify',
  'Notes : rotation': 'Notes: rotation',
  'Notes : rotation (contrôle)': 'Notes: rotation (check)',
  'Titre sur la couverture': 'Title on the cover',
};
export default m;
